<template>
  <div class="card-wrapper">
    <!--头部-->
    <!--头部-->
    <!--头部-->
    <div class="head box">
      <div class="head-tab box">
        <div class="tab-item box" :class="tab =='member'?'active':'' " @click="tab = 'member'">成员</div>
        <div class="tab-item box" :class="tab =='shenhe'?'active':'' " @click="tab = 'shenhe'">
          待审核
          <!--待审核数目 右上角绝对定位-->
          <div v-if="shenheList.length" class="remark">{{shenheList.length}}</div>
        </div>
      </div>
      <div v-if="tab == 'shenhe'" class="pass">
        <Button class="bkcc-btn btn1" @click="handleClickReview(1)">审核通过</Button>
      </div>
      <div v-if="tab == 'shenhe'" class="fail">
        <Button class="bkcc-btn btn1" @click="handleClickReview(0)">审核不通过</Button>
      </div>
      <Button type="primary" @click="showAddMember">添加成员</Button>
    </div>

    <div v-if="tab == 'member'" class="tab-content">
      <div class="box content-wrapper">
        <div
          v-for="(item,index) in memberList"
          class="item"
          @mouseenter="showZhezhao = true;picIndex=index"
          @mouseleave="mouseLeave"
        >
          <div class="pic-wrapper">
            <img :src="item.pic||require('@/assets/images/default.png')" />
            <!--遮罩层 删除-->
            <div
              class="zhezhao iconfont icon-delete"
              v-if="showZhezhao && picIndex==index"
              @click="showDel(item)"
            ></div>
          </div>
          <div class="name">{{item.name}}</div>
        </div>
      </div>
      <div class="box" style="justify-content: flex-end">
        <Page
          :total="pageTotal"
          show-total
          :page-size="18"
          @on-change="pageChange"
          :current="memberPage"
        />
      </div>
    </div>

    <div v-else class="tab-content">
      <div class="box content-wrapper">
        <div v-for="(item,index) in shenheList" class="item shenhe" @click="handleShenhe(item)">
          <div class="checkbox">
            <Checkbox
              v-model="item.isSelect"
              @click.native.stop="handleClickCheck(item)"
              :disabled="item.realNameStatus!=1?true:false"
            ></Checkbox>
          </div>
          <img :src="item.pic||require('@/assets/images/default.png')" />
          <div class="label">待审核</div>
          <div class="name">{{item.name}}</div>
        </div>
      </div>
      <div class="bottom">
        <div class="cb-wrapper">
          <Checkbox v-model="checkAll" @click.native.stop="handleCheckAll"></Checkbox>全选(当前页)
        </div>
        <Page
          :total="pageTotal"
          show-total
          :page-size="18"
          @on-change="pageChange"
          :current="shenhePage"
        />
      </div>
    </div>
    <Modal @on-visible-change="onVisibleChange" :value="showCheckMsg" title="审核说明">
      <Input type="textarea" v-model="checkMsg" :rows="10" />
      <div slot="footer">
        <Button style="margin-right:10px" @click="showCheckMsg = false">取消</Button>
        <Button type="primary" @click="review" :loading="isLoading">确定</Button>
      </div>
    </Modal>
    <!--新建弹窗-->
    <Modal v-model="showModal" title="添加成员" :mask-closable="false" class="modal" width="670">
      <div class="add-wrapper box">
        <!--弹窗中左半部分-->
        <div class="add-left box_f1 box_v">
          <!--搜索框-->
          <Input
            placeholder="请输入成员名称"
            v-model="peoplename"
            clearable
            @on-enter="inputSearch"
            @on-clear="clearSearch"
            class="input"
          />
          <Button
            type="primary"
            slot="extra"
            class="btn"
            @click="selectAll"
          >{{isSelectAll?'取消全选':'全选'}}</Button>
          <!--搜索结果-->
          <div class="people-list box" id="search">
            <div
              v-for="(item,index) in searchList"
              class="people-item box_v"
              :class="item.isSelect?'active':''"
              @click="peopleSelect(item)"
            >
              <img :src="item.pic||require('@/assets/images/default.png')" />
              <div class="name">{{item.name}}</div>
              <!--选择后的右上角的对勾-->
              <img
                v-if="item.isSelect"
                class="xuanzhong-icon color"
                src="../../../assets/images/select.png"
              />
            </div>
          </div>
        </div>
        <!--弹窗中间分割线-->
        <div class="line"></div>
        <!--弹窗中右半部分-->
        <div class="add-right box">
          <div v-for="(item,index) in selectList" class="member-item">
            {{item.name}}
            <i class="iconfont icon-quxiao1" @click="delSelect(item)"></i>
          </div>
        </div>
      </div>
      <div slot="footer" class="box" style="justify-content: flex-end">
        <Button class type="text" @click="showModal = false">取消</Button>
        <Button class type="primary" :loading="btnLoading" @click="submitPeople">确定</Button>
      </div>
    </Modal>
    <Modal v-model="isShowDelete" title="删除" width="660px">
      <div>确定删除该成员吗？</div>
      <div slot="footer" class="box" style="justify-content: flex-end">
        <Button class type="text" @click="isShowDelete = false;showZhezhao = false">取消</Button>
        <Button class type="primary" :loading="btnLoading" @click="delMember">确定</Button>
      </div>
    </Modal>
    <!--已审核过的弹窗-->
    <Modal v-model="showShenheModal" title="审核">
      <div>该人员已实名认证,是否同意加入组织</div>
      <div slot="footer" class="box" style="justify-content: flex-end">
        <Button class type="text" @click="shenhePass(0)">不同意</Button>
        <Button class type="primary" @click="shenhePass(1)">同意</Button>
      </div>
    </Modal>
    <!--已审核过的弹窗-->
    <Modal v-model="showShimingModal" title="审核">
      <div>该人员未实名认证,请前往实名认证审核</div>
      <div slot="footer" class="box" style="justify-content: flex-end">
        <Button class type="text" @click="showShimingModal = false">取消</Button>
        <Button class type="primary" @click="gotoCitizenDetail(1)">确定</Button>
      </div>
    </Modal>
    <Spin fix v-if="showSpin"></Spin>
  </div>
</template>

<script>
export default {
  name: "orgMember",
  props: {
    id: null,
    communityId: null,
    comeType: null
  },
  data() {
    return {
      memberList: [],
      shenheList: [],
      searchList: [],
      tab: "member",
      showModal: false, //是否显示添加成员弹窗
      peoplename: "", //搜索的成员名称
      btnLoading: false, //弹窗底部按钮加载状态
      isload: false, //是否正在加载
      noData: false,
      rows: 18,
      selectList: [],
      isSelectAll: false, //是否已经全选  初始未全选
      serachPage: 1,
      showZhezhao: false, //是否显示当前照片的索引值
      picIndex: -1, //鼠标滑过的照片的索引值
      delUnionId: "", //准备删除的人员unionid
      isShowDelete: false, //是否显示删除弹窗
      shenhePeople: "", //要审核的人员
      showShenheModal: false, //是否显示审核弹窗（已实名认证的）
      showShimingModal: false, //是否显示审核弹窗（未实名认证的）
      memberTotal: 0, //成员总数 分页器用
      shenheTotal: 0, //审核总数  分页器用
      memberPage: 1,
      shenhePage: 1,
      showSpin: false,
      checkMsg: "",
      showCheckMsg: false,
      isLoading: false,
      status: null,
      checkAll: false
    };
  },
  watch: {
    id(newV, oldV) {
      this.getMember();
    }
  },
  computed: {
    pageTotal() {
      if (this.tab == "member") {
        return this.memberTotal;
      } else {
        return this.shenheTotal;
      }
    }
  },
  methods: {
    //显示人员搜索添加框
    //自动调一次搜索
    showAddMember() {
      this.showModal = true;
      this.searchList = [];
      this.serachPage = 1;
      this.noData = false;
      this.getAllRealName();
    },
    //人员搜索
    inputSearch() {
      this.searchList = [];
      this.serachPage = 1;
      this.noData = false;
      console.log(this.peoplename);
      this.getAllRealName();
    },
    //清空人员搜索
    clearSearch() {
      console.log("clear");
    },
    //搜索要添加的人  从全部实名认证中搜索
    getAllRealName() {
      this.isload = true;
      var url = this.urlobj.getAllRealName;
      this.$post(url, {
        realName: this.peoplename,
        pageNum: 1,
        pageSize: 21,
        orgId: this.id,
        communityId: this.communityId,
        comeType: this.comeType
      }).then(res => {
        if (res.rows.length < 6) this.noData = true;
        this.isload = false;
        var list = res.rows.map(item => {
          return {
            name: item.realName,
            pic: item.headPicUrl,
            isSelect: false,
            id: item.id,
            unionId: item.unionId
          };
        });
        this.searchList = this.searchList.concat(list);
      });
    },
    // 选择搜索结果中的人员
    peopleSelect(item) {
      if (item.isSelect) {
        //取消选择
        item.isSelect = false;
        //已选择列表中删除此选项
        this.selectList.forEach((_item, _index) => {
          if (item.id == _item.id) {
            this.selectList.splice(_index, 1);
            return;
          }
        });
        //此时全选状态一定是未全选
        this.isSelectAll = false;
      } else {
        //选择
        item.isSelect = true;
        //将此选项加入已选择列表
        this.selectList.push({
          name: item.name,
          id: item.id,
          unionId: item.unionId
        });
        //已选列表长度  和  搜索结果长度相同  说明已经全选  此时按钮变为取消全选
        if (this.selectList.length == this.searchList.length)
          this.isSelectAll = true;
      }
    },
    // 点击全选/取消全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.isSelectAll = false;
        //点击的是 取消全选按钮
        this.searchList.forEach(item => {
          item.isSelect = false;
        });
        this.selectList = [];
      } else {
        this.isSelectAll = true;
        this.selectList = [];
        // 点击的是全选按钮
        this.searchList.forEach(item => {
          item.isSelect = true;
          this.selectList.push({
            name: item.name,
            id: item.id,
            unionId: item.unionId
          });
        });
      }
    },
    //点击右侧删除按钮 取消选择
    delSelect(item) {
      console.log(item);
      //从已选择列表中删除
      this.selectList.forEach((_item, _index) => {
        if (item.id == _item.id) {
          this.selectList.splice(_index, 1);
        }
      });
      //将搜索结果中该人员选择状态变为未选择
      this.searchList.forEach(_item => {
        if (item.id == _item.id) _item.isSelect = false;
      });
      //将是否全选状态  变为 未全选
      this.isSelectAll = false;
    },
    // handleScroll() {
    //   var that = this
    //   var a = document.getElementById("search");
    //   var scrollTop = a.scrollTop; //变量scrollTop是滚动条滚动时，距离顶部的距离
    //   var windowHeight = a.clientHeight; //变量windowHeight是可视区的高度
    //   var scrollHeight = a.scrollHeight; //变量scrollHeight是滚动条的总高度
    //   if (scrollTop + windowHeight + 10 > scrollHeight) {
    //     //写后台加载数据的函数
    //     console.log("触底");
    //     if (!that.isload && !that.noData) {
    //       ++this.serachPage;
    //       that.getAllRealName();
    //     }
    //   }
    // },
    //获取成员列表
    getMember() {
      var getAllMember = this.getAllMember();
      var getDaishenhe = this.getDaishenhe();
      this.showSpin = true;
      Promise.all([getAllMember, getDaishenhe]).then(res => {
        this.showSpin = false;
        this.memberList = res[0];
        this.shenheList = res[1];
        this.shenheList = this.shenheList.map(item => {
          item.isSelect = false;
          return item;
        });
      });
    },
    getAllMember() {
      return new Promise((resolve, reject) => {
        var url = this.urlobj.getOrgMember;
        this.$post(url, {
          id: this.id,
          pageNum: this.memberPage,
          pageSize: this.rows,
          isRealName: 1 //1 已审核
        })
          .then(res => {
            this.memberTotal = res.total;
            var list = res.rows.map(item => {
              return {
                name: item.realName,
                pic: item.headPicUrl,
                id: item.id,
                unionId: item.unionId
              };
            });
            resolve(list);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getDaishenhe() {
      return new Promise((resolve, reject) => {
        var url = this.urlobj.getOrgMember;
        this.$post(url, {
          id: this.id,
          pageNum: this.shenhePage,
          pageSize: this.rows,
          isRealName: -1 //-1待审核
        })
          .then(res => {
            this.shenheTotal = res.total;
            var list = res.rows.map(item => {
              return {
                name: item.realName,
                pic: item.headPicUrl,
                id: item.id,
                realNameStatus: item.realNameStatus,
                unionId: item.unionId
              };
            });
            resolve(list);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    // 页码改变
    pageChange(num) {
      console.log(this.tab);
      if (this.tab == "member") {
        this.memberPage = num;
        this.getAllMember().then(res => {
          this.memberList = res;
        });
      } else {
        this.shenhePage = num;
        this.showSpin = true;
        this.getDaishenhe().then(res => {
          this.showSpin = false;
          this.shenheList = res;
          this.shenheList = this.shenheList.map(item => {
            item.isSelect = false;
            return item;
          });
        });
      }
    },
    //提交要添加的人
    submitPeople() {
      var list = this.selectList;
      if (!list.length) {
        this.$Message.warning("请选择人员");
        return;
      }
      var unionId = list
        .map(item => {
          return item.unionId;
        })
        .join();
      var url = this.urlobj.saveOrgMember;
      this.$post(url, {
        unionId,
        orgId: this.id,
        status: 1 //-1为待审核，1为审核通过，0为审核不过(PC传1，小程序传-1)
      }).then(res => {
        this.showModal = false;
        this.memberPage = 1;
        this.getAllMember().then(res => {
          this.memberList = res;
        });
      });
    },
    //鼠标移开头像
    mouseLeave() {
      //如果删除弹窗已经显示了  鼠标移开时就不取消遮罩层了
      if (!this.isShowDelete) {
        this.showZhezhao = false;
      }
    },
    //点击遮罩层的垃圾桶  弹出删除窗
    showDel(item) {
      this.delUnionId = item.unionId;
      this.isShowDelete = true;
    },
    // 点击删除窗的确定  删除人员
    delMember() {
      var url =
        this.urlobj.delOrgMember +
        "?orgId=" +
        this.id +
        "&unionId=" +
        this.delUnionId;
      this.$delete(url).then(res => {
        this.isShowDelete = false;
        this.showZhezhao = false;
        this.$Message.success("删除成功");
        this.memberPage = 1;
        this.showSpin = true;
        this.getAllMember().then(res => {
          this.showSpin = false;
          this.memberList = res;
        });
      });
    },
    //点击待审核的人
    //点击的人已经实名认证通过了   直接加入组织
    // 点击的人没实名通过  去实名认证界面
    handleShenhe(item) {
      this.shenhePeople = item;
      if (item.realNameStatus != 1) {
        this.showShimingModal = true;
      } else {
        this.showShenheModal = true;
      }
    },
    gotoCitizenDetail() {
      this.$router.push({
        name: "citizenDetail",
        params: {
          unionId: this.shenhePeople.unionId,
          communityId: this.communityId,
          isOrg: 1,
          peopleid: this.shenhePeople.id
        }
      });
    },
    //同意或者拒绝加入组织
    shenhePass(status) {
      var url = this.urlobj.orgShenhe;
      this.$post(url, {
        id: this.shenhePeople.id, // org2user对象ID,
        status, //1为审核通过，0为审核不过
        comeType: this.comeType
      }).then(res => {
        this.showShenheModal = false;
        console.log("11111111111111");
        this.getMember();
        if (status) {
          this.$Message.success("已通过");
        } else {
          this.$Message.error("已拒绝");
        }
      });
    },
    handleClickCheck(item) {
      this.$nextTick(() => {
        let Ids = this.shenheList
          .filter(item => item.isSelect)
          .map(item => item.id);
        let validCheckedList = this.shenheList.filter(
          item => item.realNameStatus == 1
        );
        if (Ids.length == validCheckedList.length) {
          this.checkAll = true;
        } else {
          this.checkAll = false;
        }
      });
    },
    onVisibleChange(val) {
      if (!val) {
        this.showCheckMsg = false;
        this.checkMsg = "";
      }
    },
    async review() {
      if (!this.checkMsg) {
        return this.$Message.info("请填写审核说明");
      }
      this.isLoading = true;
      try {
        let Ids = this.shenheList
          .filter(item => item.isSelect)
          .map(item => item.id);
        console.log(Ids);
        let res = await this.$post(this.urlobj.orgShenhe, {
          status: this.status,
          checkMsg: this.checkMsg,
          ids: Ids.join(",")
        });
        this.showCheckMsg = false;
        this.$Message.success("操作成功");
        this.getDaishenhe().then(res => {
          this.shenheList = res;
          this.shenheList = this.shenheList.map(item => {
            item.isSelect = false;
            return item;
          });
          this.getAllMember().then(res => {
            this.memberList = res;
          });
          this.checkAll = false;
        });
      } finally {
        this.isLoading = false;
      }
    },
    handleClickReview(status) {
      this.status = status;
      let Ids = this.shenheList
        .filter(item => item.isSelect)
        .map(item => item.id);
      if (!Ids.length) {
        return this.$Message.info("请勾选要审核的成员");
      }
      this.showCheckMsg = true;
    },
    handleCheckAll() {
      this.checkAll = !this.checkAll
        ? this.shenheList
            .filter(item => item.realNameStatus == 1)
            .map(item => (item.isSelect = true))
        : this.shenheList
            .filter(item => item.realNameStatus == 1)
            .map(item => (item.isSelect = false));
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   document
    //     .getElementById("search")
    //     .addEventListener("scroll", this.handleScroll);
    // });
  }
};
</script>

<style scoped lang="less">
.card-wrapper /deep/ .ivu-btn {
  padding: 1px 15px 2px;
}
.card-wrapper /deep/ .ivu-btn {
  padding: 1px 15px 2px;
}
.card-wrapper /deep/ .ivu-page-item {
  background: #f1f1f1;
}
.card-wrapper /deep/ .ivu-page-prev,
.ivu-page-next {
  background: #f1f1f1;
}
.card-wrapper /deep/ .ivu-page-next {
  background: #f1f1f1;
}

.modal /deep/ .ivu-btn {
  padding: 1px 15px 2px;
}
.card-wrapper {
  width: 98%;
  margin: auto;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  position: relative;
}
.pass {
  flex: 1;
  text-align: right;
}
.fail {
  // margin-left: auto;
  margin-right: 10px;
}
.checkbox {
  position: absolute;
  top: -5px;
}
.bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.cb-wrapper {
  margin-right: 15px;
}
button.bkcc-btn.btn1 {
  background: #f9fafa;
  border: 1px solid #dedede;
  color: #4b4b4b;
  &:hover {
    background: #ff5a32;
    border: 1px solid #ff5a32;
    color: #fff;
  }
  &:active {
    background: #ff7b44;
    border: 1px solid #ff7b44;
    color: #fff;
  }
}
.head {
  padding: 0 20px;
  border-bottom: 1px solid #ddd;
  height: 60px;
  align-items: center;
  justify-content: space-between;
  font-size: 19px;
  color: #4b4b4b;
  .head-tab {
    height: calc(100% - 1px);
    .tab-item {
      align-items: center;
      height: 100%;
      &:first-child {
        margin-right: 25px;
      }
      &:last-child {
        position: relative;
      }
      .remark {
        height: 15px;
        min-width: 15px;
        background: #d22b2b;
        color: #fff;
        border-radius: 15px;
        line-height: 15px;
        text-align: center;
        position: absolute;
        top: 5px;
        right: -13px;
        font-size: 12px;
        padding: 0 3px;
      }
    }
    .active {
      color: #ff7744;
      border-bottom: 2px solid #ff7744;
    }
  }
}
.tab-content {
  padding: 20px;
  .content-wrapper {
    text-align: center;
    flex-wrap: wrap;
    line-height: 1;
    .item {
      margin-right: 20px;
      margin-bottom: 20px;
      position: relative;
      font-size: 16px;
      .pic-wrapper {
        height: 70px;
        width: 70px;
        border-radius: 50%;
        position: relative;
        margin-bottom: 10px;
        .zhezhao {
          height: 70px;
          width: 70px;
          border-radius: 50%;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          font-size: 40px;
          line-height: 70px;
        }
      }
      img {
        height: 70px;
        width: 70px;
        border-radius: 50%;
        margin-bottom: 10px;
        /*margin-bottom: 20px;*/
      }
    }
    .shenhe {
      img {
        margin-bottom: 20px;
      }
      .label {
        height: 18px;
        width: 50px;
        line-height: 18px;
        text-align: center;
        border-radius: 10px;
        background: #ff7744;
        color: #fff;
        font-size: 12px;
        position: absolute;
        top: 61px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
.add-wrapper {
  line-height: 1;
  height: 320px;
  .add-left {
    .input {
      margin-bottom: 20px;
    }
    .btn {
      align-self: flex-end;
      margin-bottom: 10px;
    }
    .people-list {
      flex-wrap: wrap;
      overflow-y: scroll;
      padding-top: 10px;
      &::-webkit-scrollbar {
        width: 2px;
        height: 2px;
        background-color: #fff;
      }
      &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #fff;
      }
      &::-webkit-scrollbar-thumb {
        height: 20px;
        border-radius: 10px;
        background-color: #ccc;
      }
      .people-item {
        width: 120px;
        height: 150px;
        border-radius: 5px;
        border: 1px solid #e5e5e5;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        margin-bottom: 20px;
        position: relative;
        img {
          height: 50px;
          width: 50px;
          border-radius: 50%;
          margin-bottom: 20px;
        }
        .name {
          font-size: 12px;
          color: #333;
        }
        .xuanzhong-icon {
          position: absolute;
          top: -11px;
          right: -12px;
          height: 20px;
          width: 20px;
        }
      }
      .active {
        border: 1px solid #ff7b44;
      }
    }
  }
  .line {
    width: 1px;
    background: #dedede;
    margin: 0 20px;
  }
  .add-right {
    width: 190px;
    flex-wrap: wrap;
    line-height: 1;
    justify-content: space-between;
    overflow-y: scroll;
    align-content: flex-start;
    &::-webkit-scrollbar {
      width: 2px;
      height: 2px;
      background-color: #fff;
    }
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #fff;
    }
    &::-webkit-scrollbar-thumb {
      height: 20px;
      border-radius: 10px;
      background-color: #ccc;
    }
    .member-item {
      height: 24px;
      line-height: 24px;
      font-size: 14px;
      color: #999;
      padding: 0 10px;
      border: 1px dashed #d2d2d2;
      border-radius: 4px;
      margin-bottom: 30px;
      .iconfont {
        color: #bbb;
        margin-left: 5px;
      }
    }
  }
}
</style>
